// extracted by mini-css-extract-plugin
export default {"layout":"SettingsLayout_layout__zZqAr","pane":"SettingsLayout_pane__vtqZP","loading":"SettingsLayout_loading__NvXEI","empty":"SettingsLayout_empty__FLQrH"};